import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _taggedTemplateLiteral from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// @ts-ignore

/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
var defaultOptions = {};
export var CatalogueProductCardDataFragmentDoc = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    fragment CatalogueProductCardData on Product {\n  __typename\n  id\n  title\n  ratingsSummary {\n    numberOfRatings\n    averageRating\n  }\n  assets {\n    hero {\n      url\n      altText\n    }\n  }\n  brand {\n    name\n    slug\n  }\n  priceTag {\n    priceDiscount {\n      label\n      percentageLabel\n      endDate\n    }\n    topLabel\n    priceLabel {\n      wasPrice {\n        amount\n      }\n      price {\n        amount\n      }\n      saving {\n        label\n        savingAmount {\n          amount\n        }\n      }\n    }\n    clubSellPrice {\n      amount\n    }\n    clubExclusive\n    enabled\n    retailPriceDisclaimer {\n      description\n    }\n  }\n  bestOffer {\n    id\n    clubExclusive\n    clubFreeShipping\n    freeShipping\n    sellPrice {\n      amount\n    }\n    seller {\n      id\n      name\n    }\n    badges\n  }\n  options {\n    name\n  }\n  sellable\n  slug\n  adult\n}\n    "])));
export var SearchSponsoredPriceTagFragmentDoc = gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    fragment SearchSponsoredPriceTag on PriceTag {\n  priceDiscount {\n    label\n    percentageLabel\n    endDate\n  }\n  topLabel\n  priceLabel {\n    wasPrice {\n      amount\n    }\n    price {\n      amount\n    }\n    saving {\n      label\n      savingAmount {\n        amount\n      }\n    }\n  }\n  clubSellPrice {\n    amount\n  }\n  clubExclusive\n  enabled\n  retailPriceDisclaimer {\n    description\n  }\n}\n    "])));
export var SearchSponsoredProductCardFragmentDoc = gql(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    fragment SearchSponsoredProductCard on Product {\n  __typename\n  id\n  title\n  ratingsSummary {\n    numberOfRatings\n    averageRating\n  }\n  assets {\n    hero {\n      url\n      altText\n    }\n  }\n  brand {\n    name\n    slug\n  }\n  priceTag {\n    ...SearchSponsoredPriceTag\n  }\n  selectedOffer {\n    id\n    clubExclusive\n    clubFreeShipping\n    freeShipping\n    sellPrice {\n      amount\n    }\n    seller {\n      id\n      name\n    }\n    badges\n    priceTag {\n      ...SearchSponsoredPriceTag\n    }\n  }\n  options {\n    name\n  }\n  sellable\n  slug\n  adult\n}\n    ", ""])), SearchSponsoredPriceTagFragmentDoc);
export var PageBannerDocument = gql(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    query PageBanner($input: BannerByPageInput!) {\n  bannerByPage(input: $input) {\n    banners {\n      id\n      url\n      platforms\n      image {\n        url\n        altText\n        height\n        width\n      }\n    }\n  }\n}\n    "])));
/**
 * __usePageBannerQuery__
 *
 * To run a query within a React component, call `usePageBannerQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageBannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageBannerQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */

export function usePageBannerQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(PageBannerDocument, options);
}
export function usePageBannerLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(PageBannerDocument, options);
}
export function usePageBannerSuspenseQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useSuspenseQuery(PageBannerDocument, options);
}
export var SearchDocument = gql(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    query Search($input: SearchInput!) {\n  search(input: $input) {\n    pageTitle\n    searchTerm\n    totalResults\n    containsAdult\n    pagination {\n      page\n      totalPages\n    }\n    results {\n      id\n      product {\n        ...CatalogueProductCardData\n      }\n    }\n    categories {\n      displayName\n      options {\n        id\n        count\n        displayName\n        slug\n        path\n        selected\n        children {\n          id\n          count\n          displayName\n          slug\n          path\n          selected\n          children {\n            id\n            count\n            displayName\n            slug\n            path\n            selected\n            children {\n              id\n              count\n              displayName\n              slug\n              path\n              selected\n            }\n          }\n        }\n      }\n    }\n    facets {\n      availableFacets {\n        ... on SearchRangeFacet {\n          __typename\n          id\n          name\n          displayName\n          type\n          hidden\n          totalApplied\n          min\n          max\n          minLabel\n          maxLabel\n          selectedRange {\n            min\n            max\n          }\n        }\n        ... on SearchListFacet {\n          __typename\n          id\n          name\n          displayName\n          type\n          hidden\n          totalApplied\n          options {\n            id\n            value\n            displayName\n            selected\n            count\n            children {\n              id\n              value\n              displayName\n              selected\n              count\n              leaf\n            }\n            leaf\n          }\n        }\n      }\n      appliedFacets {\n        key\n        value\n        displayName\n      }\n    }\n    sortOptions {\n      key\n      label\n      selected\n      direction\n    }\n    metadata {\n      snowplowContexts\n    }\n  }\n}\n    ", ""])), CatalogueProductCardDataFragmentDoc);
/**
 * __useSearchQuery__
 *
 * To run a query within a React component, call `useSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */

export function useSearchQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(SearchDocument, options);
}
export function useSearchLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(SearchDocument, options);
}
export function useSearchSuspenseQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useSuspenseQuery(SearchDocument, options);
}
export var NoResultsCategoryNavDocument = gql(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    query NoResultsCategoryNav($domain: String!) {\n  cmsConfiguration {\n    header(input: {domain: $domain}) {\n      megaMenu {\n        navData {\n          shops {\n            id\n            name\n            url\n            image\n          }\n        }\n      }\n    }\n  }\n}\n    "])));
/**
 * __useNoResultsCategoryNavQuery__
 *
 * To run a query within a React component, call `useNoResultsCategoryNavQuery` and pass it any options that fit your needs.
 * When your component renders, `useNoResultsCategoryNavQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNoResultsCategoryNavQuery({
 *   variables: {
 *      domain: // value for 'domain'
 *   },
 * });
 */

export function useNoResultsCategoryNavQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(NoResultsCategoryNavDocument, options);
}
export function useNoResultsCategoryNavLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(NoResultsCategoryNavDocument, options);
}
export function useNoResultsCategoryNavSuspenseQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useSuspenseQuery(NoResultsCategoryNavDocument, options);
}
export var SearchRedirectsDocument = gql(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    query SearchRedirects {\n  searchRedirects {\n    redirects {\n      searchTerm\n      targetPath\n    }\n  }\n}\n    "])));
/**
 * __useSearchRedirectsQuery__
 *
 * To run a query within a React component, call `useSearchRedirectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchRedirectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchRedirectsQuery({
 *   variables: {
 *   },
 * });
 */

export function useSearchRedirectsQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(SearchRedirectsDocument, options);
}
export function useSearchRedirectsLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(SearchRedirectsDocument, options);
}
export function useSearchRedirectsSuspenseQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useSuspenseQuery(SearchRedirectsDocument, options);
}
export var SearchSponsoredProductsDocument = gql(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    query SearchSponsoredProducts($inventoryId: String!, $limit: Int, $searchQuery: String, $snowplowSessionId: String, $customerUUID: String, $facets: FacetInput) {\n  retailMediaProducts(\n    input: {inventoryId: $inventoryId, snowplowSessionId: $snowplowSessionId, searchQuery: $searchQuery, limit: $limit, customerUUID: $customerUUID, facets: $facets}\n  ) {\n    products {\n      ...SearchSponsoredProductCard\n    }\n    tracking {\n      id\n      clickTrackingUrl\n      impressionTrackingUrl\n      productId\n    }\n  }\n}\n    ", ""])), SearchSponsoredProductCardFragmentDoc);
/**
 * __useSearchSponsoredProductsQuery__
 *
 * To run a query within a React component, call `useSearchSponsoredProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSponsoredProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSponsoredProductsQuery({
 *   variables: {
 *      inventoryId: // value for 'inventoryId'
 *      limit: // value for 'limit'
 *      searchQuery: // value for 'searchQuery'
 *      snowplowSessionId: // value for 'snowplowSessionId'
 *      customerUUID: // value for 'customerUUID'
 *      facets: // value for 'facets'
 *   },
 * });
 */

export function useSearchSponsoredProductsQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(SearchSponsoredProductsDocument, options);
}
export function useSearchSponsoredProductsLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(SearchSponsoredProductsDocument, options);
}
export function useSearchSponsoredProductsSuspenseQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useSuspenseQuery(SearchSponsoredProductsDocument, options);
}